import React from 'react'
import { Helmet } from 'react-helmet'
import './termeni.css'

const Termeni = () => {
  return (
    <div className="terms-container">
      <Helmet>
        <title>Termeni și Condiții - Sustin.ro</title>
        <meta property="og:title" content="Termeni și Condiții - Sustin.ro" />
      </Helmet>

      <img
        alt="background"
        src="/external/map.svg"
        className="terms-map"
      />

      <div className="terms-content">
        <h1>Termeni și Condiții</h1>
        
        <section className="terms-section">
    <h2>1. Definiții</h2>
    <ul>
      <li>
        <p>
          <strong>Operator</strong>: În acest context, Operatorul se referă la entitatea juridică care deține și administrează platforma Sustin.ro. Operatorul se ocupă de furnizarea serviciilor, de gestionarea datelor și de respectarea reglementărilor legale aplicabile.
        </p>
      </li>
      <li>
        <p>
          <strong>Utilizator</strong>: Persoana fizică sau juridică care accesează site-ul Sustin.ro și utilizează serviciile oferite. Utilizatorul poate fi un contribuabil care dorește să direcționeze 3,5% din impozitul pe venit către o organizație nonprofit.
        </p>
      </li>
      <li>
        <p>
          <strong>Servicii</strong>: Totalitatea funcționalităților puse la dispoziție de platformă, incluzând completarea și depunerea Formularului 230, organizarea tombolelor cu premii și administrarea programului de afiliere.
        </p>
      </li>
    </ul>
  </section>

  <section className="terms-section">
    <h2>2. Acceptarea condițiilor</h2>
    <p>
      Prin accesarea și utilizarea Sustin.ro, confirmați în mod expres că ați citit și că sunteți de acord cu toți termenii și condițiile prezentate în acest document. Dacă nu sunteți de acord cu oricare dintre prevederi, vă rugăm să întrerupeți imediat utilizarea site-ului.
    </p>
  </section>

  <section className="terms-section">
    <h2>3. Eligibilitate</h2>
    <ul>
      <li>
        <p><strong>Vârsta minimă</strong>: Trebuie să aveți cel puțin 18 ani pentru a putea redirecționa 3,5% din impozitul pe venit.</p>
      </li>
      <li>
        <p><strong>Rezidență fiscală</strong>: Trebuie să fiți contribuabil și rezident fiscal în România, pentru a putea direcționa 3.5% din impozitul pe venit.</p>
      </li>
      <li>
        <p><strong>Capacitate juridică</strong>: Trebuie să aveți capacitatea legală de a redirecționa 3,5% din impozitul pe venit și de a furniza informații precise și conforme realității.</p>
      </li>
    </ul>
  </section>

  <section className="terms-section">
    <h2>4. Descrierea serviciilor</h2>
    <ul>
      <li>
        <p>
          <strong>Formularul 230</strong>: Platforma noastră asigură completarea corectă a Formularului 230, care permite redirecționarea a 3,5% din impozitul pe venit către o organizație nonprofit. După completare, noi ne ocupăm de depunerea documentului la ANAF în termenul legal.
        </p>
      </li>
      <li>
        <p>
          <strong>Tombole și premii</strong>: Organizăm două tipuri de tombole pentru utilizatorii platformei:
        </p>
        <ul>
          <li>
            <p><strong>Tombola generală</strong>: Toți utilizatorii care completează Formularul 230 sunt automat înscriși într-o tombolă prin care pot câștiga o vacanță de 6 nopți pentru 14 persoane la o cabană de lux.</p>
          </li>
          <li>
            <p><strong>Programul de afiliere</strong>: Utilizatorii pot participa la un program de afiliere cu două niveluri de recompense:</p>
            <ul>
              <li><p>La colectarea a 10 formulare completate prin link-urile lor de afiliere și validate, participanții intră într-o tombolă prin care pot câștiga o vacanță de 6 nopți pentru 14 persoane la o cabană de lux.</p></li>
              <li><p>La colectarea a 100 de formulare completate prin link-urile lor de afiliere și validate, participanții primesc garantat o vacanță de 4 nopți pentru 2-4 persoane la o cabană de lux.</p></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </section>

  <section className="terms-section">
    <h2>5. Regulile tombolelor și programului de afiliere</h2>
    <ul>
      <li>
        <p><strong>Condiții generale</strong>: Toate premiile sunt condiționate de atingerea unui număr total de 10.000 de formulare înregistrate prin platformă și validate de ANAF. În cazul în care acest număr nu este atins, nu se oferă premii. Perioadele pentru sejururile câștigate vor fi stabilite de comun acord între operator și câștigător în funcție de disponibilitate.</p>
      </li>
      <li>
        <p><strong>Eligibilitate</strong>:</p>
        <ul>
          <li><p>Pentru tombola generală: toți utilizatorii care completează Formularul 230 sunt automat eligibili, dacă formularul completat este validat de ANAF.</p></li>
          <li><p>Pentru programul de afiliere: utilizatorul trebuie să îndeplinească condițiile de eligibilitate pentru fiecare nivel de recompensă: 10 sau 100 de formulare completate și validate de ANAF, în funcție de nivelul de recompensă.</p></li>
        </ul>
      </li>
      <li>
        <p><strong>Validarea formularelor</strong>: Un formular este considerat valid doar după ce a fost procesat și acceptat de ANAF. Numărul de formulare necesar pentru recompense se bazează pe formularele validate.</p>
      </li>
      <li>
        <p><strong>Distribuția premiilor</strong>: Premiile vor fi distribuite în ordinea înregistrării formularelor validate. În cazul în care mai mulți participanți ating același prag în aceeași zi, se va aplica un sistem de prioritate bazat pe data și ora înregistrării primului formular.</p>
      </li>
      <li>
        <p><strong>Termenul pentru distribuția premiilor</strong>: Premiile vor fi distribuite cel mai târziu la finalul lunii decembrie 2025.</p>
      </li>
      <li>
        <p><strong>Limitări</strong>: Fiecare persoană poate câștiga maximum o vacanță prin tombola generală și una pentru fiecare nivel de recompensă din programul de afiliere. Nu se pot acumula mai multe vacanțe din același nivel de recompensă.</p>
      </li>
    </ul>
  </section>

  <section className="terms-section">
    <h2>6. Drepturile și obligațiile utilizatorilor</h2>
    <ul>
      <li>
        <p><strong>Furnizarea de informații corecte</strong>: Utilizatorii trebuie să ofere date exacte și actualizate, pentru a asigura validitatea Formularului 230 și buna desfășurare a tombolelor sau a programului de afiliere.</p>
      </li>
      <li>
        <p><strong>Respectarea regulamentelor</strong>: Orice utilizare a serviciilor trebuie să fie conformă cu prezentul document și cu orice regulamente specifice tombolelor sau programelor de afiliere.</p>
      </li>
    </ul>
  </section>

  <section className="terms-section">
    <h2>7. Responsabilități și limitarea răspunderii</h2>
    <p>
      Operatorul nu poate garanta că redirecționarea impozitului sau participarea la tombolă va duce întotdeauna la rezultate specifice. De asemenea, nu răspundem pentru întreruperi sau erori cauzate de factori externi, forță majoră sau incidente tehnice. Utilizarea platformei se face pe riscul propriu al utilizatorului.
    </p>
  </section>

  <section className="terms-section">
    <h2>8. Proprietate intelectuală</h2>
    <p>
      Toate materialele (texte, imagini, sigle, mărci comerciale) afișate pe Sustin.ro sunt protejate de legislația drepturilor de autor. Fără acordul scris al Operatorului, orice reproducere, distribuire sau utilizare a acestor materiale este strict interzisă.
    </p>
  </section>

  <section className="terms-section">
    <h2>9. Modificarea Termenilor</h2>
    <p>
      Ne rezervăm dreptul de a actualiza acești Termeni și Condiții oricând, fără notificare prealabilă. Orice modificare va fi afișată pe site cu data revizuirii. Continuarea utilizării serviciilor după data actualizării implică acceptarea noilor termeni.
    </p>
  </section>

  <section className="terms-section">
    <h2>10. Legislație aplicabilă și soluționarea litigiilor</h2>
    <p>
      Acest acord este guvernat de legislația în vigoare din România. În cazul unei dispute, părțile vor încerca soluționarea amiabilă; dacă acest lucru nu este posibil, litigiile vor fi înaintate instanțelor competente din România.
    </p>
  </section>

    <div className="gdpr-footer">
        <p>
          Pentru întrebări sau clarificări privind acești termeni, vă rugăm să ne contactați la:<br />
      Email: <a href="mailto:hi@romania.org.ro">hi@romania.org.ro</a><br />
          </p>
        </div>
      </div>
    </div>
  )
}

export default Termeni 